import { Component, OnInit, Host, Optional, Input, HostListener, AfterViewInit, ElementRef } from '@angular/core';
import { ActivatedRoute, NavigationStart, Route, Router, RouterEvent } from '@angular/router';
import { UserService as _userService } from '@ff/user';
import { MatSidenav } from '@angular/material/sidenav';
import { UserService } from '@ff/user';

import { Subject, filter } from 'rxjs';
import { User } from '../../_models/user';
import { Role } from '../../_models/role';
import { isNil } from 'lodash';

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss']
})
export class NavigationComponent implements OnInit, AfterViewInit {
  //private _user: User;
  private _routes: Route[] = [];
  private _mobileRoutes: Route[] = [];
  expanded = {
    workspace: false,
    administration: false,
    indexes: false
  };
  isMobile = new Subject();
  _user: User;

  constructor(@Host() @Optional() private _sidenav: MatSidenav,
    public _userService: _userService,
    private _router: Router,
    public userService: UserService,
    public _elementRef: ElementRef,
  ) {
    
  }

  ngOnInit(): void {
    this._user = new User(this._userService._user.getValue());
  }
  
  canViewAdminMenu(): boolean {
    let res = false;
    if (!isNil(this._user)) {
      this._user.roles.forEach((r: Role) => {
        const adminPermissions = r.permissions.administration;
        res ||= (adminPermissions?.currencies?.edit && adminPermissions?.workspaces?.edit && adminPermissions?.users?.edit &&
          adminPermissions?.loading_sites?.edit && adminPermissions?.indexes?.edit && adminPermissions?.packagings?.edit && adminPermissions?.sales_organisations?.edit
        );
      });
    }

    return res;
  }

  isMenuActive(menu: string): boolean {
    let currentPath =  this._router.url;
    let pathElements = currentPath.split('/');
    pathElements.splice(pathElements.length - 1, 1)
    return currentPath != "" && pathElements.includes(menu);
  }

  expand(label: string): void {
    this._router.events.pipe(filter((event: RouterEvent) => {return( event instanceof NavigationStart );}))
    .subscribe({
      next: (event: NavigationStart) => {
        
      }
    });
    this.expanded[label] = !this.expanded[label];
    Object.keys(this.expanded).forEach(key => {
      if (this.expanded[label] && label != key) {
        this.expanded[key] = false;
      }
    });
  }

  ngAfterViewInit(): void {
    this.detectScreenSize();
  }

  private detectScreenSize() {
    this.isMobile.next(window.innerWidth < 992);
  }

  public getRoutes(mobile = false): Route[] {
    return mobile ? this._mobileRoutes : this._routes;
  }

  public close(): void {
    if (this._sidenav) {
      this._sidenav.close();
    }
  }

}
